import React, { Component, Fragment } from "react";
import axios from "axios";

import HotelListItem from "../../components/HotelListItem/HotelListItem";
import Footer from '../../common/Footer';

class HomePage extends Component {

	constructor(props) {
		super(props);
		document.title = 'Hotel list';
	}

	state = {
		hotels: []
	};

	componentDidMount() {
		axios.get("/api/hotels")
			.then(response => {
				console.log('hotel adatok: ', response.data);
				this.setState({
					hotels: response.data
				})
			})
	}

	sortZA = () => {
		const updatedHotelList = [...this.state.hotels]
		updatedHotelList.sort((hotel1, hotel2) => {
			if (hotel1.name > hotel2.name) return -1;
			if (hotel1.name < hotel2.name) return 1;
			return 0;
		});
		this.setState({
			hotels: updatedHotelList
		})
	};

	render() {

		const bgStyle = {
			height: "50vh",
			backgroundImage: "url('../assets/img/profile_city.jpg')",
			marginTop: "-20px"
		};
		return (
			<Fragment>
				<div className="page-header header-filter" data-parallax="true"
				     style={bgStyle}>
					<div className="container">
						<div className="row">
							<div className="col-md-6">
								<h1 className="title">Your Travel Starts With Us.</h1>
								<h4>Nobody can discover the world for somebody else. <br/>
									Only when we discover it for ourselves does it become common ground and a common
									bond and we cease to be alone.</h4>
								<br/>

							</div>
						</div>
					</div>
				</div>
				<div className="main main-raised" style={{marginBottom: "60px"}}>
					<div className="container">
						<div className="section text-center" style={{paddingTop: "20px"}}>
							<h1 className="title">Hotels</h1>
							<span onClick={this.sortZA}>
		                        <img
			                        style={{
				                        width: 24,
				                        cursor: 'pointer',
				                        position: 'relative',
				                        left: '48%',
				                        bottom: 68
			                        }}
			                        src="https://cdn.pixabay.com/photo/2012/04/11/11/17/sort-27489_960_720.png"
			                        alt="a-z"
		                        />
	                        </span>
							<div className="row">
								{this.state.hotels.map((hotel, index) =>
									<HotelListItem
										key={hotel.id}
										id={hotel.id}
										name={hotel.name}
										address={hotel.address}
										imageUrl={hotel.imageUrl}
										numberOfRooms={hotel.numberOfRooms}
										totalBeds={hotel.totalBeds}
										averageRatings={hotel.averageRatings}
										differentColorButton={index === 5}
									/>
								)}
							</div>
						</div>
					</div>
				</div>
				<Footer/>
			</Fragment>
		)
	}
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/containers/HomePage/HomePage.jsx